// extracted by mini-css-extract-plugin
module.exports = {"root":"Distance-module__root--1-VTK"};